<template>
  <div class="p16">
    <div>
      <div>
        <span
          class="hide-shimmer-text shimmer-container rounded p2 fs-16 text-transparent"
        >
          offers
        </span>
        <span
          class="hide-shimmer-text shimmer-container rounded ml8 p2 fs-16 text-transparent"
          >random title image</span
        >
      </div>
    </div>
    <div class="pt16">
      <ul class="scrollable-container">
        <li
          v-for="index in length"
          :key="index"
          class="shimmer-container rounded offers-home-card-shimmer"
        >
          <div
            class="shimmer-container rounded hide-shimmer-text shimmer-header"
          >
            offer listing card header description
          </div>
          <div
            class="shimmer-container rounded hide-shimmer-text shimmer-footer"
          >
            offer listing card footer description
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "OffersHomeShimmer",
  data() {
    return {
      length: 4,
    };
  },
};
</script>
